import { render, staticRenderFns } from "./EducationForm.vue?vue&type=template&id=50347dde"
import script from "./EducationForm.vue?vue&type=script&lang=ts"
export * from "./EducationForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50347dde')) {
      api.createRecord('50347dde', component.options)
    } else {
      api.reload('50347dde', component.options)
    }
    module.hot.accept("./EducationForm.vue?vue&type=template&id=50347dde", function () {
      api.rerender('50347dde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/profile/educations/EducationForm.vue"
export default component.exports